import { Component, OnInit } from '@angular/core';
import { OrdersService } from 'app/services/orders.service';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from 'environments/environment';
import { PrintService } from 'app/services/print.service';

@Component({
  selector: 'print-step-6',
  styleUrls: ['../../wizard/wizard.component.scss', './step6.component.scss'],
  templateUrl: './step6.component.html',
})
export class PrintStep6Component implements OnInit {
  trackingUrl;

  constructor(
    private ordersService: OrdersService,
    private sanitizer: DomSanitizer,
    private printService: PrintService
  ) {}

  ngOnInit() {
    this.trackOrder();
    this.printService.initializeWizard();
  }

  trackOrder() {
    if (!environment.production) { return false; }

    this.ordersService.get().subscribe((response: any) => {
      const order = response.results[0];
      const id = order.id;
      const value = ((+order.pricing.product + +order.pricing.shipping - +order.pricing.discount) / 1.2).toFixed(2);
      const eventId = response.count > 1 ? '353816' : '357963';
      const url =
        `https://tbs.tradedoubler.com/report?organization=2079753&event=${eventId}&orderNumber=${id}&orderValue=${value}&currency=EUR`;
      this.trackingUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    });
  }
}
